import { render, staticRenderFns } from "./FaceTake.vue?vue&type=template&id=2097c8f4&scoped=true&"
import script from "./FaceTake.vue?vue&type=script&lang=js&"
export * from "./FaceTake.vue?vue&type=script&lang=js&"
import style0 from "./FaceTake.vue?vue&type=style&index=0&id=2097c8f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2097c8f4",
  null
  
)

export default component.exports